import * as React from "react";
import {
  TaskBoardCardBody,
} from "@progress/kendo-react-taskboard";
import { classNames } from "@progress/kendo-react-common";
import { Card, CardHeader } from "@progress/kendo-react-layout";
import TaskPreviewPane from "./TaskPreviewPane";


// const images: { [id: string]: string } = {};
// cards.forEach((card) => {
//   images[String(card.id)] = card.description;
// });

interface ITaskBoardCardProps {
  task: any;
  style?: any;
  elementRef?: any;
  disabled?: boolean;
  onShowPreviewPane: (event: any) => void;
  previewDialogPriorityLabel: string;
  onClosePreviewPane: (event: any) => void;
  showTaskPreviewPane: boolean;
}


const TaskBoardCard = (props: ITaskBoardCardProps) => {
  const {
    task,
    style,
    elementRef,
    disabled,
    onShowPreviewPane,
    previewDialogPriorityLabel,
    onClosePreviewPane,
    showTaskPreviewPane,
  } = props;

  const renderTitleDisplay = () => {
    if (task.titleNumber && task.titleName) {
      return (<div><b>Title:</b> {task.titleNumber}, {task.titleName}</div>);
    }
    if (task.titleNumber) {
      return (<div><b>Title:</b> {task.titleNumber}</div>);
    }
    if (task.titleName) {
      return (<div><b>Title:</b> {task.titleName}</div>);
    }
    return (<div><b>Title:</b></div>);
  }

  const renderChapterDisplay = () => {
    return (<div><b>Chapters:</b> <ul>{task.associatedChapters.map((chapter: any) => (
      <li>
        {chapter.chapterName && chapter.chapterNumber ? (
          <li>{chapter.chapterNumber}: {chapter.chapterName}</li>
        ) : chapter.chapterName ? (
          <li>{chapter.chapterName}</li>
        ) : (
          <li>{chapter.chapterNumber}</li>
        )}
      </li>
    ))}</ul></div>)
  }

  return (
    <>
      <Card
        key={String(task.id)}
        style={style}
        ref={elementRef}
        className={classNames(
          "k-taskboard-card k-taskboard-card-category taskboard-card",
          {
            "k-disabled": disabled,
          }
        )}
      >
        <CardHeader>
          <div onClick={onShowPreviewPane} className="clickable-card-header">
            {task.title}
          </div>
        </CardHeader>
        <TaskBoardCardBody task={task}>
          <div><b>Docket #:</b> {task.docketNumberDto?.docketNumber}</div>
          <div><b>Filing Created On:</b> {new Date(task.filedOn).toLocaleDateString()}</div>
          <div><b>Filing Type:</b> {task.filingFormName}</div>
          <div><b>Agency:</b> {task.agencyName}</div>
          {renderTitleDisplay()}
          <div><b>Date Accepted:</b> {!!task.effectiveOn ? new Date(task.effectiveOn).toLocaleDateString() : "N/A"}</div>
          {renderChapterDisplay()}
          <br />
          <div>{task.filingDetail.description}</div>
        </TaskBoardCardBody>
      </Card>
      {showTaskPreviewPane && (
        <TaskPreviewPane
          title={task.title}
          priorityLabel={'Status' ?? previewDialogPriorityLabel}
          onClosePreviewPane={onClosePreviewPane}
          priority={task.priority}
          filing={task}
        />
      )}
    </>
  );
};

export { TaskBoardCard as Card }